export const NewsletterConfig = ($stateProvider) => {
  'ngInject';
  $stateProvider.state('app.newsletter', {
    url: '^/newsletter',
    template: '<newsletter></newsletter>'
  });
  $stateProvider.state('app.subscriberListing', {
    url: '^/subscribers',
    template: '<subscriber-listing></subscriber-listing>'
  });
};


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/newsletter/components/newsletter.config.js
 **/